<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <router-link :to="{ name: 'ViewManualAppraisal', params: { id: id } }"
        class="mb-0 main-identifier fw-semibold text-decoration-none">
        Imported Appraisal
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Edit Imported Appraisal</p>
    </div>

    <div class="d-flex justify-content-center mb-5">

      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Edit Imported Appraisal</h1>
              </div>

              <div class="form-body mt-2 mb-3">

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="date_completed"
                      class="form-label">Appraisal Completion Date</label></div>
                  <div class="col-md-7 input-right">
                    <input id="date_completed" type="date" class="form-control" v-model="appraisalCompletionDate"
                      :max="maxDateCompleted" :min="minDateCompleted" required>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Originating MDA</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input" v-model="form.originatingMda"
                      placeholder="" readonly>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Approval Authority</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input" v-model="form.approvalAuthority"
                      placeholder="" readonly>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Budget Year</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input" v-model="form.budgetYear"
                      placeholder="" readonly>
                  </div>
                </div>
                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Initiator</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input" v-model="form.initiatorName"
                      placeholder="" readonly>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Group Head</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input" v-model="form.sectoralHeadName"
                      placeholder="" readonly>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Director of Budget</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input" v-model="form.dobName"
                      placeholder="" readonly>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Permanent Secretary</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input" v-model="form.psName" placeholder=""
                      readonly>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Commissioner</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input" v-model="form.commissionerName"
                      placeholder="" readonly>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Quarter</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input" v-model="form.quarter"
                      placeholder="" readonly>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Nature of Expenditure</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input" :value="natureOfExpenditureLabel"
                      placeholder="" readonly>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Amount Approved</label></div>
                  <div class="col-md-7 input-right">
                    <input type="text" class="form-control form-view-only-input"
                      :value="'₦' + formatCurrency(form.amountApproved || 0)" placeholder="" readonly>
                  </div>
                </div>
              </div>

              <div class="row mb-3 budget-item-wrapper step-2 justify-content-center">
                <div class="row content-wrapper section-border h-100 w-100">
                  <div class="col d-flex">
                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                      <label class="form-label fw-bold fixed-label">Organizational Code</label>
                      <input type="text" class="form-control view-only-input text-center" v-model="form.orgCode"
                        readonly>
                    </div>
                  </div>
                  <div class="col d-flex">
                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                      <label class="form-label fw-bold fixed-label">Approved Budget Amount</label>
                      <input type="text" class="form-control view-only-input text-center"
                        :value="'₦' + formatCurrency(form.approvedBudgetAmount || 0)" readonly />
                    </div>
                  </div>

                  <div class="col d-flex">
                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                      <label class="form-label fw-bold fixed-label">Approved Released To Date</label>
                      <input type="text" class="form-control view-only-input text-center"
                        :value="'₦' + formatCurrency(form.amtReleasedToDate || 0)" readonly />
                    </div>
                  </div>
                  <div class="col d-flex">
                    <div class="d-flex flex-column justify-content-center h-100 w-100">
                      <label class="form-label fw-bold fixed-label">Balance</label>
                      <input type="text" class="form-control view-only-input text-center"
                        :value="'₦' + formatCurrency(form.balance || 0)" readonly />
                    </div>
                  </div>
                </div>
                <div class="table-responsive mt-4">
                  <table class="table table-bordered appraisal-view text-center align-middle">
                    <thead class="table-light">
                      <tr>
                        <th>Eco Code</th>
                        <th>Title</th>
                        <th>Approved Budget {{ form.budgetYear }}</th>
                        <th>Approval Release To Date</th>
                        <th>Balance</th>
                        <th>Amount Approved</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in economicItems" :key="index"
                        :class="index % 2 === 0 ? 'row-even' : 'row-odd'">
                        <td>{{ item.ecoCode }}</td>
                        <td>{{ item.title }}</td>
                        <td>₦{{ formatCurrency(item.amountBudgeted || 0) }}</td>
                        <td>₦{{ formatCurrency(item.amountReleased || 0) }}</td>
                        <td>₦{{ formatCurrency(item.balance || 0) }}</td>
                        <td>₦{{ formatCurrency(item.amountApproved || 0) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Evaluation Remark</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <textarea type="text" class="form-control form-view-only-input" v-model="form.evalRemarks"
                        placeholder="" readonly>
                      </textarea>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Total Amount Approved</label></div>
                  <div class="col-md-7">
                    <input type="text" class="form-control form-view-only-input"
                      :value="'₦' + formatCurrency(form.amountApproved)" placeholder="" readonly>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group"
                  v-if="form.sectoralHeadRemarks">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Sectoral Remark</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.sectoralHeadRemarks"
                        placeholder="" readonly>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group" v-if="form.dobRemarks">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Director of Budget Remark</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.dobRemarks"
                        placeholder="" readonly>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group" v-if="form.permSecRemarks">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Permanent Secretary Remark</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.permSecRemarks"
                        placeholder="" readonly>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 row form-group position-relative floating-label-group"
                  v-if="form.commissionerRemarks">
                  <div class="col-md-5 label-left d-flex justify-content-end align-items-center"><label for="year"
                      class="form-label">Commissioner Remark</label></div>
                  <div class="col-md-7 input-right">
                    <div class="col-md-12 input-right">
                      <input type="text" class="form-control form-view-only-input" v-model="form.commissionerRemarks"
                        placeholder="" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-4">
              <div class="d-flex justify-content-center gap-3">
                <button type="submit" class="btn btn-primary submit-btn" :disabled="loading || !isDataLoaded">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                    aria-hidden="true"></span>
                  {{ (loading ? 'Submitting...' : 'Submit') }}
                </button>
              </div>
            </div>

          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import { useRoute, useRouter } from 'vue-router';

const root_api_url = process.env.VUE_APP_API_ROOT_URL
const route = useRoute()
const router = useRouter()
const id = route.params.id

const loading = ref(false)
const isDataLoaded = ref(false)

// Full, untouched copy of whatever the GET endpoint returned - sent back as-is on submit.
const rawData = ref(null)

// Read-only display fields (mirrors ViewManualAppraisalPage.vue)
const form = reactive({
  originatingMda: '',
  approvalAuthority: '',
  natureOfExpenditure: '',
  amountApproved: '',
  approvedBudgetAmount: '',
  amtReleasedToDate: '',
  balance: '',
  quarter: '',
  budgetYear: '',
  evalRemarks: '',
  orgCode: '',
  sectoralHeadRemarks: '',
  dobRemarks: '',
  permSecRemarks: '',
  commissionerRemarks: '',
  initiatorName: '',
  sectoralHeadName: '',
  dobName: '',
  psName: '',
  commissionerName: '',
})

const economicItems = ref([])

// The only editable field
const appraisalCompletionDate = ref('')

const maxDateCompleted = new Date().toISOString().split('T')[0]
const minDateCompleted = (() => {
  const d = new Date()
  d.setFullYear(d.getFullYear() - 3)
  return d.toISOString().split('T')[0]
})()

function toDateInputValue(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  if (isNaN(date.getTime())) return ''
  return date.toISOString().split('T')[0]
}

function formatCurrency(val) {
  if (val === '' || val === null || val === undefined) return '';
  const num = Number(val);
  if (isNaN(num)) return '';
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const natureOfExpenditureLabel = computed(() => {
  return form.natureOfExpenditure == 2
    ? 'Recurrent'
    : form.natureOfExpenditure == 3
      ? 'Capital'
      : form.natureOfExpenditure == 4
        ? 'Hybrid'
        : ''
})

const fetchAppraisal = async () => {
  const token = Cookies.get('auth_token')
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`
  try {
    const { data } = await axios.get(`${root_api_url}/appraisal/appraisal/import/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })

    rawData.value = data

    form.originatingMda = data.originatingMda
    form.approvalAuthority = data.approvalAuthority
    form.natureOfExpenditure = data.natureOfExpenditure
    form.amountApproved = data.amountApproved
    form.approvedBudgetAmount = data.approvedBudgetAmount
    form.amtReleasedToDate = data.amtReleasedToDate
    form.balance = data.balance
    form.quarter = data.quarter
    form.budgetYear = data.budgetYear
    form.evalRemarks = data.evalRemarks
    form.orgCode = data.orgCode
    form.sectoralHeadRemarks = data.sectoralHeadRemarks
    form.dobRemarks = data.dobRemarks
    form.permSecRemarks = data.permSecRemarks
    form.commissionerRemarks = data.commissionerRemarks
    form.initiatorName = data.initiatorName
    form.sectoralHeadName = data.sectoralHeadName
    form.dobName = data.dobName
    form.psName = data.psName
    form.commissionerName = data.commissionerName

    appraisalCompletionDate.value = toDateInputValue(data.appraisalCompletionDate || data.issueDate)

    economicItems.value = (data.appraisalEconomicItems || []).map(dto => ({
      ecoCode: dto.ecoCode,
      title: dto.title,
      amountBudgeted: dto.amountBudgeted,
      amountReleased: dto.amountReleased,
      balance: dto.balance,
      amountApproved: dto.amountApproved,
    }))

    isDataLoaded.value = true
  } catch (err) {
    console.error('Error loading appraisal:', err)
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${err?.response?.data?.errorMessage || err?.response?.data?.error || err?.response?.data?.message || 'Failed to load appraisal details. Please try again.'}</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
  }
}

const handleSubmit = async () => {
  const token = Cookies.get('auth_token');

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  if (!appraisalCompletionDate.value) {
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>Appraisal Completion Date is required</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
    return;
  }

  if (appraisalCompletionDate.value > maxDateCompleted || appraisalCompletionDate.value < minDateCompleted) {
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>Appraisal Completion Date must be between ${minDateCompleted} and ${maxDateCompleted}</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    });
    return;
  }

  // Everything comes back exactly as fetched - only the completion date changes.
  const appraisalData = {
    ...rawData.value,
    appraisalCompletionDate: appraisalCompletionDate.value,
  }
  delete appraisalData.errorMessage

  loading.value = true;

  try {
    await axios.put(`${root_api_url}/appraisal/appraisal/import/${id}`, appraisalData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Appraisal Updated Successfully</p> `,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    }).then(() => {
      router.push({ name: 'ViewManualAppraisal', params: { id } })
    });

  } catch (error) {
    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage ?? error?.response?.data?.error ?? error?.response?.data?.message ?? "Unexpected error occurred while updating the appraisal. Kindly contact administrator"}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred while updating the appraisal. Kindly contact administrator.</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  await fetchAppraisal()
  document.title = "Edit Imported Appraisal"
})
</script>

<style scoped>
.col-md-5 {
  width: 35% !important
}

.view-only-input,
.form-view-only-input {
  border: none !important;
  background-color: transparent;
  padding-left: 0;
  cursor: default;
  pointer-events: none;
  color: #212529;
  font-size: 1rem;
}

.dashboard-layout .budget-item-wrapper {
  margin-top: 20px;
  padding: 0 20px;
}

.dashboard-layout .budget-item-wrapper .col {
  border: 1px solid #212529;
}

.dashboard-layout .budget-item-wrapper .col-md-5 {
  border: 1px solid #212529;
}

.dashboard-layout .fixed-label {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 4rem;
  width: 100%;
  padding: 0 0.25rem;
  box-sizing: border-box;
  text-align: center;
}

.table-bordered.appraisal-view th {
  font-size: 14px;
}

.table-bordered.appraisal-view thead {
  background: none;
}

.table-bordered.appraisal-view thead th {
  border: 1px solid black;
  background: none;
}

.table-bordered.appraisal-view tbody {
  background: none;
}

.table-bordered.appraisal-view tbody td {
  border: 1px solid black;
  background: none;
}
</style>
